import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutModule } from './layout/layout/layout.module';
import { MaterialModule } from './material.module';

import { CereriModule } from './components/cereri/cereri.module';
import { ConfirmareDocumenteModule } from './components/confirmare-documente/confirmare-documente.module';

import { HttpClientModule } from '@angular/common/http';
import { httpInterceptorProviders } from './interceptors';
import { DepartmentsModule } from './platform/nomenclatoare/departments/departments.module';
import { AdminSetariModule } from './platform/nomenclatoare/administrativ/admin-setari/admin-setari.module';
import { SettingsModule } from './components/settings/settings.module';
import { TokenGuard } from './guards/token.guard';
import { TokenComponent } from './components/token/token.component';
import { ToastrModule } from 'ngx-toastr';

@NgModule({
    declarations: [AppComponent, TokenComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        LayoutModule,
        MaterialModule,
        SettingsModule,
        CereriModule,
        HttpClientModule,
        DepartmentsModule,
        AdminSetariModule,
        ToastrModule.forRoot(),
        ConfirmareDocumenteModule,
    ],
    providers: [httpInterceptorProviders, TokenGuard],
    bootstrap: [AppComponent],
})
export class AppModule { }
